// Transfer only a public destination. Never copy callback fragments, checkout
// references, bank return parameters, guest capabilities, or donor data.
export function browserHandoffUrl(pathname: string, origin: string, locale: string): string {
  const allowed =
    /^\/(?:p\/[^/]+|o\/[^/]+|give\/[^/]+\/[^/]+|give\/fund\/[^/]+\/[^/]+|organizations\/[^/]+\/projects\/[^/]+|basket|sign-in)\/?$/;
  const safeSegments =
    !pathname.includes('\\') && !pathname.split('/').some((part) => part === '.' || part === '..');
  const path = safeSegments && allowed.test(pathname) ? pathname : '/';
  const url = new URL(path, origin);
  url.search = '';
  url.hash = '';
  url.searchParams.set('lang', ['ro', 'en', 'hu'].includes(locale) ? locale : 'ro');
  return url.href;
}
